import React from 'react'
import { Question } from '../../models/Question'

export function SurveyQuestion({
  index,
  question,
  disabled = false,
  handleOnChange = () => undefined,
}: {
  index: number
  question: Question
  disabled?: boolean
  handleOnChange: React.ChangeEventHandler<HTMLInputElement>
}) {
  return (
    <div className="py-5 flex flex-col">
      <label
        className="text-sm font-medium text-gray-500 pb-1"
        htmlFor={`question-${question.url}`}
      >
        {index + 1}. {question.text}
      </label>
      <div className="flex flex-row">
        <input
          className="border py-2 px-3 text-grey-darkest flex-auto rounded"
          type="text"
          name={`question-${question.url}`}
          id={`question-${question.url}`}
          placeholder="Enter a value"
          onChange={handleOnChange}
          disabled={disabled}
        />
      </div>
    </div>
  )
}
